"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16PromoFill = function Svg16PromoFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.712 4.725a1 1 0 0 0-1.924 0l-.009.032c-.156.547-.185.61-.212.651a.555.555 0 0 1-.159.159c-.04.027-.104.056-.651.212l-.032.01a1 1 0 0 0 0 1.923l.032.009c.547.156.61.185.651.212a.555.555 0 0 1 .159.159c.027.04.056.104.212.651l.01.032a1 1 0 0 0 1.923 0l.009-.032c.156-.547.185-.61.212-.651a.555.555 0 0 1 .159-.159c.04-.027.104-.056.651-.212l.032-.01a1 1 0 0 0 0-1.923l-.032-.009c-.547-.156-.61-.185-.651-.212a.555.555 0 0 1-.159-.159c-.027-.04-.056-.104-.212-.651l-.01-.032zm6.25 2a1 1 0 0 0-1.923 0l-.031.109c-.494 1.726-.691 2.378-1.037 2.903a4.333 4.333 0 0 1-1.234 1.234c-.525.346-1.177.543-2.903 1.037l-.109.03a1 1 0 0 0 0 1.923l.109.031c1.726.494 2.378.691 2.903 1.037.49.323.91.743 1.234 1.234.346.525.543 1.177 1.037 2.903l.03.109a1 1 0 0 0 1.923 0l.031-.109c.494-1.726.691-2.378 1.037-2.903a4.333 4.333 0 0 1 1.234-1.234c.525-.346 1.177-.543 2.903-1.037l.109-.03a1 1 0 0 0 0-1.923l-.109-.031c-1.726-.494-2.378-.691-2.903-1.037a4.333 4.333 0 0 1-1.234-1.234c-.346-.525-.543-1.177-1.037-2.903l-.03-.109z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16PromoFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16PromoFill;
exports.default = _default;